import axios            from "axios";

const axiosStore = () => {
  const csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  let custom_headers = {}
  if(csrf_token) custom_headers['X-CSRF-Token'] = csrf_token
  const client = axios.create({
    headers: custom_headers,
  });
  return client;
}

export const orderProduct = async (data) => {
  const csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  let custom_headers = {'content-type': 'multipart/form-data'}
  if(csrf_token) custom_headers['X-CSRF-Token'] = csrf_token
  const client = axios.create({headers: custom_headers});
  const url = `/orders/populate`
  try {
    return (await client.post(url, data));
  } catch (err) {
    throw err
  }
}

export const removeItemsfromOrder = async (items_to_destroy) => {
  const csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  let custom_headers = {'content-type': 'multipart/form-data'}
  if(csrf_token) custom_headers['X-CSRF-Token'] = csrf_token
  const form = new FormData();
  form.append('utf8', '✓')
  form.append('_method', 'patch')
  items_to_destroy.forEach((id, idx) => {
    form.append(`order[line_items_attributes][${idx}][id]`, id)
    form.append(`order[line_items_attributes][${idx}][quantity]`, 0)
  })
  const client = axios.create({headers: custom_headers});
  const url = `/cart`
  try {
    return (await client.post(url, form));
  } catch (err) {
    throw err
  }
}

export const populateSaleQuote = async (body) => {
  const url = '/orders/populate_sale_quote.json';
  return axios.post(url, body);
};
